import { atom } from 'recoil';
// Global message (green alert)
//
// hideMessage:
//  - true  - auto-hide after 5 seconds
//  - false - "sticky" message (used across navigation, e.g. after booking)
//
// wasShown:
//  - used only for sticky messages (hideMessage = false)
//  - becomes true after the message was visible for a short time
//  - prevents the message from being shown again on the next page
//  - (c) Vadim 04/2026
export const globalMessageState = atom({
    key: 'globalMessageState',
    default: {
      isVisible: false, 
      text: '',
      hideMessage: true,
      // wasShown: false,
      // Optional: restrict message to a specific route
      targetPath: null as string | null,
    },
  });

// Global error (red alert)
// Same logic as globalMessageState
  export const globalErrorState = atom({
    key: 'globalErrorState',
    default: {
      isVisible: false, 
      text: '',
      hideMessage: true,
      // wasShown: false,
      // Optional: restrict message to a specific route
      targetPath: null as string | null,
    },
  });

// Atom to reload trips form server
export const reloadTrips = atom({
  key: 'reloadTrips',
  default: false
});


// 